import { Component, OnInit } from '@angular/core';
import { Globals } from '../../_models/globals';
import { ApiIntegration } from '../../_services/api.integration';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { EditAccountOwner } from '../../_models/editAccountOwner';
import { Address } from '../../_models/address';
import { User } from '../../_models/user';
import * as _ from "lodash";
import { AlertService } from '../../_services/alert.service';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';


@Component({
  selector: 'app-edit-account-owner-list',
  templateUrl: './edit-account-owner-list.component.html',
  styleUrls: ['./edit-account-owner-list.component.css']
})
export class EditAccountOwnerListComponent implements OnInit {
  errorMessage: string = "";
  statusText1: string;
  statusText2: string;
  statusText3: string;
  statusText4: string;
  statusText5: string;
  statusText6: string;
  statusText7: string;
  statusText8: string;
  statusText9: string;
  noOfDays: string;

  account: EditAccountOwner = {
    companyName: "",
    ownerName: "",
    mobile: 0,
    email: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    zip: 0,
    status: "",
    expiryDate: "",
    addressId: ''
  }
  addressT: any;
  statesList: any;
  addressTypes: any = [];
  accountCommAddress: Address = {};
  panNoerrorMessage: string;
  pancardError: string;
  panCard: string;
  panCardPhotoError: string;
  imagepanCard: string;
  aadhar: string;
  aadharNumberError: string;
  aadharPhoto: string;
  aadharPhotoError: string;
  imageAadhar: string;
  mouError: string;
  imageUrl: string;
  citiesList: any;

  constructor(private alertService: AlertService, private user: User, private g: Globals, private api: ApiIntegration, private route: ActivatedRoute, private router: Router, private http: HttpClient) {
    this.g.page = "Edit Customer";
    this.stateList();
    this.cityList();
    this.g.loaderDisplay = "display";
    this.api.getAccountOwner(this.route.snapshot.params['id']).subscribe((data: EditAccountOwner) => {
      this.account = data;
      this.g.loaderDisplay = "";
      for (let add of this.account.adddressList) {
        this.accountCommAddress = _.cloneDeep(add);
      }
    }, err => {
      this.alertService.error('Error', err);
      this.g.loaderDisplay = "";
    });
    this.g.loaderDisplay = "display";
    this.api.getValues("1", "ADDRESS_TYPE", "ADDRESS_TYPE", "ADDRESS_TYPE").subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.addressTypes = data.tripleSetConfigDTOS;
    }, err => {
      console.log(err);
      this.g.loaderDisplay = "";
    });

  }

  stateList() {
    this.api.getDistinctStates().subscribe((data: any) => {
      this.statesList = data;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  cityList() {
    this.api.getDistinctCity().subscribe((data: any) => {
      this.citiesList = data;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  changeCityAndState() {
    this.api.getCityAndStateByPinCode(this.accountCommAddress.zip).subscribe((data: any) => {
      this.accountCommAddress.city = data.city;
      this.accountCommAddress.state = data.state;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  checkPanNo() {
    this.panNoerrorMessage = "";
    let regex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    if (this.account.panCardNumber && !regex.test(this.account.panCardNumber)) {
      this.panNoerrorMessage = "Invalid PAN Number";
    }
  }

  loadPancard(event) {
    this.account.panCard = event.target.files[0];

    this.submitPancard();
  }

  loadAadhar(event) {
    this.account.aadharCard = event.target.files[0];
    this.submitAadhar();
  }

  loadImage(event) {
    this.account.mouDocument = event.target.files[0];

    this.submitImage();
  }

  ngOnInit() {
  }

  submitPancard() {
    this.g.loaderDisplay = "display";
    const file = this.account.panCard;
    const formData: FormData = new FormData();
    formData.append('file', file);
    var headerObj = new HttpHeaders();
    headerObj = headerObj.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/uploadImageToS3', formData, { headers: headerObj }).subscribe(data => {
      this.g.loaderDisplay = "";
      if (data['code'] == 200) {
        this.imagepanCard = data['message'];
      } else {
        this.imagepanCard = "";
      }
    },
      (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
        this.errorMessage = "Upload Image Failed Please Re-try";
      });
  }

  submitAadhar() {
    this.g.loaderDisplay = "display";
    const file = this.account.aadharCard;
    const formData: FormData = new FormData();
    formData.append('file', file);
    var headerObj = new HttpHeaders();
    headerObj = headerObj.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/uploadImageToS3', formData, { headers: headerObj }).subscribe(data => {
      this.g.loaderDisplay = "";
      if (data['code'] == 200) {
        this.imageAadhar = data['message'];
      } else {
        this.imageAadhar = "";
      }
    },
      (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
        this.errorMessage = "Upload Image Failed Please Re-try";
      });
  }

  submitImage() {
    this.g.loaderDisplay = "display";
    const file = this.account.mouDocument;
    const formData: FormData = new FormData();
    formData.append('file', file);
    var headerObj = new HttpHeaders();
    headerObj = headerObj.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/uploadImageToS3', formData, { headers: headerObj }).subscribe(data => {
      this.g.loaderDisplay = "";
      if (data['code'] == 200) {
        this.imageUrl = data['message'];
      } else {
        this.imageUrl = "";
      }
    },
      (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
        this.errorMessage = "Upload Image Failed Please Re-try";
      });
  }

  typeCompanyName() {
    this.statusText1 = "";
    if (this.account.companyName == '' || this.account.companyName === null || this.account.companyName === undefined || this.account.companyName === 'undefined') {
      this.statusText1 = 'Please enter company name';
    }
  }

  typeContactName() {
    this.statusText2 = "";
    if (this.account.ownerName == '' || this.account.ownerName === null || this.account.ownerName === undefined || this.account.ownerName === 'undefined') {
      this.statusText2 = 'Please enter contact name';
    }
  }

  typeAddress() {
    this.statusText4 = "";
    if (this.accountCommAddress.address1 == '' || this.accountCommAddress.address1 === null || this.accountCommAddress.address1 === undefined || this.accountCommAddress.address1 === 'undefined') {
      this.statusText4 = 'Please enter address1';
    }
  }

  typeCity() {
    this.statusText6 = "";
    if (this.accountCommAddress.city == '' || this.accountCommAddress.city === null || this.accountCommAddress.city === undefined || this.accountCommAddress.city === 'undefined') {
      this.statusText6 = 'Please enter city';
    }
  }

  typeState() {
    this.statusText7 = "";
    if (this.accountCommAddress.state == '' || this.accountCommAddress.state === null || this.accountCommAddress.state === undefined || this.accountCommAddress.state === 'undefined') {
      this.statusText7 = 'Please enter state';
    }
  }

  typeZip() {
    this.statusText8 = "";
    if (this.accountCommAddress.zip === null || this.accountCommAddress.zip === undefined) {
      this.statusText8 = 'Please enter zip';
    }
  }

  createAccountOwner() {
    this.statusText1 = "";
    this.statusText2 = "";
    this.statusText3 = "";
    this.statusText4 = "";
    this.statusText5 = "";
    this.statusText6 = "";
    this.statusText7 = "";
    this.statusText8 = "";
    this.aadharNumberError = "";
    this.panNoerrorMessage = "";
    if (this.account.companyName == '' || this.account.companyName === null || this.account.companyName === undefined || this.account.companyName === 'undefined') {
      this.statusText1 = 'Please enter company name';
    }
    if (this.account.ownerName == '' || this.account.ownerName === null || this.account.ownerName === undefined || this.account.ownerName === 'undefined') {
      this.statusText2 = 'Please enter contact name';
    }
    if (this.account.aadhartCardNumber == '' || this.account.aadhartCardNumber === null || this.account.aadhartCardNumber === undefined || this.account.aadhartCardNumber === 'undefined') {
      this.aadharNumberError = 'Please enter aadhar number';
    }
    if (this.account.panCardNumber == '' || this.account.panCardNumber === null || this.account.panCardNumber === undefined || this.account.panCardNumber === 'undefined') {
      this.panNoerrorMessage = 'Please enter pan number';
    }
    if (this.account.email == '' || this.account.email === null || this.account.email === undefined || this.account.email === 'undefined') {
      this.statusText3 = 'Please enter email';
    }

    if (this.accountCommAddress.address1 == '' || this.accountCommAddress.address1 === null || this.accountCommAddress.address1 === undefined || this.accountCommAddress.address1 === 'undefined') {
      this.statusText4 = 'Please enter address1';
    }
    if (this.accountCommAddress.city == '' || this.accountCommAddress.city === null || this.accountCommAddress.city === undefined || this.accountCommAddress.city === 'undefined') {
      this.statusText6 = 'Please enter city';
    }
    if (this.accountCommAddress.state == '' || this.accountCommAddress.state === null || this.accountCommAddress.state === undefined || this.accountCommAddress.state === 'undefined') {
      this.statusText7 = 'Please enter state';
    }
    if (this.accountCommAddress.zip === null || this.accountCommAddress.zip === undefined) {
      this.statusText8 = 'Please enter zip';
    }
    if (this.aadharNumberError != "" || this.panNoerrorMessage != "" || this.statusText1 != "" || this.statusText2 != "" || this.statusText3 != "" || this.statusText4 != "" || this.statusText6 != "" || this.statusText7 != "" || this.statusText8 != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateAccountOwner', {
      "companyName": this.account.companyName,
      "ownerName": this.account.ownerName,
      "mobile": this.account.mobile,
      "email": this.account.email,
      "expiryDate": this.account.expiryDate,
      "addressType": this.accountCommAddress.addressType,
      "address1": this.accountCommAddress.address1,
      "address2": this.accountCommAddress.address2,
      "city": this.accountCommAddress.city,
      "state": this.accountCommAddress.state,
      "zip": this.accountCommAddress.zip,
      "organizationId": 1,
      "codPaymentDays": this.noOfDays,
      "addressId": this.account.addressId,
      "geoCode": this.accountCommAddress.geoCode,
      "id": this.route.snapshot.params['id'],
      "panCardDoc": this.imagepanCard,
      "panCardNumber": this.account.panCardNumber,
      "aadharCardDoc": this.imageAadhar,
      "aadharCardNumber": this.account.aadhartCardNumber,
      "gstNumber": this.account.gstNumber,
      "mouDocument": this.imageUrl
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";

        if (data['code'] == 200) {
          this.alertService.success('Customer', 'Edited Successfully');

          this.router.navigate(['/admin/accountOwnerList']);
        } else {
          this.alertService.error('Error', data['message']);

        }
        this.g.loaderDisplay = "";

      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          console.log(err);

        });
  }
}
